import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot } from "@angular/router";
import { ITagsWebServiceClient } from "@common/resources/resources";
import { UserStore } from "@digicerba/common";


@Injectable()
export class EnsureAdminAuthGuard implements CanActivate {

    constructor(private userStore: UserStore, private tagsWebService: ITagsWebServiceClient ) {
    }

    canActivate(route: ActivatedRouteSnapshot) {
        return this.userStore.isAdmin() || this.tagsWebService.getAccessAdminAuthorization();
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/canaux/ensure-admin-auth.guard.ts